import { Actions } from 'vuex-smart-module';
import { ReportsService } from '@/modules/reports/services';
import { Reports } from '@/modules/reports/types';
import { ReportOrderTypes } from '@/enums';
import ReportsState from './state';
import ReportsGetters from './getters';
import ReportsMutations from './mutations';

const reportsService = new ReportsService();

export default class ReportsActions extends Actions<
  ReportsState,
  ReportsGetters,
  ReportsMutations,
  ReportsActions
> {
  async get_orders_reports() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: Reports.OrdersRequest = {
        filters: this.state.filters,
        filters_exist: this.state.filters_exist,
        total_exist: this.state.total_exist,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING(true);

      const { data, meta } = await reportsService.get_orders_reports(payload);

      this.mutations.SET_REPORTS(data.items);

      if (
        (this.state.filters.type === ReportOrderTypes.READY_SHIPPED && !this.state.show_tables)
        || (this.state.filters.type !== ReportOrderTypes.READY_SHIPPED && !this.state.show_tables && this.state.filters_exist)
      ) {
        this.mutations.UPD_SHOW_TABLES(true);
      }

      if (this.state.filters_changed && this.state.filters.type !== ReportOrderTypes.READY_SHIPPED) {
        this.mutations.TOGGLE_FILTERS_CHANGED(false);
      }

      if (!this.state.filters_exist) {
        this.mutations.SET_REPORT_ORDER_FILTERS(data.filters);
        this.mutations.TOGGLE_FILTERS_EXIST(true);
      }

      if (!this.state.total_exist) {
        this.mutations.SET_TOTAL(data.total);
        this.mutations.TOGGLE_TOTAL_EXIST(true);
      }

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING(false);
    }
  }

  async get_permissions() {
    try {
      const { data } = await reportsService.get_permissions();

      this.mutations.SET_PERMISSIONS(data);
    } catch (error) {
      console.error(error);
    }
  }
}
